import { gql } from '@apollo/client';
import KEYBOARDING_CLASSROOM_SETTINGS_FRAGMENT from '../../fragments/keyboarding-classroom-settings';

const GET_KEYBOARDING_CLASSROOM_SETTINGS = gql`
  query keyClassroomSettings($where: PliClassroomSettingsWhereInput!) {
    keyClassroomSettings(where: $where) {
      ...BaseKeyboardingClassroomSettings
    }
  }
  ${KEYBOARDING_CLASSROOM_SETTINGS_FRAGMENT}
`;

export default GET_KEYBOARDING_CLASSROOM_SETTINGS;
